export class ResponseResult<T> {
    state: State;
    data: T;

    static get empty(): ResponseResult<any> {
        let response = new ResponseResult<any>();
        response.state = new State();
        response.state.count = 0;
        response.state.limit = 0;
        response.state.offset = 0;
        response.state.total = 0;

        response.data = null;

        return response;
    }
}

export class State {
    offset: number;
    limit: number;
    count: number;
    total: number;
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/state.ts